import React from 'react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { Typography, Timeline, Card } from 'antd';
import { useOwnerContext } from '../../../../../contexts/OwnerContext/OwnerContext';
import { CardTitle } from '../../../../../components/CardTitle/CardTitle';

const { Text } = Typography;

export const HistoryInfoCards = () => {
  const { t } = useTranslation();
  const { owner } = useOwnerContext();

  return (
    <Card
      title={
        <CardTitle icon="clock">{t('owners.show.history_info')}</CardTitle>
      }
    >
      <Timeline
        style={{
          maxHeight: '400px',
          overflowY: 'scroll',
          width: '100%'
        }}
      >
        {(owner?.history || []).map((event) => {
          const formattedDate = dayjs(event.date).format('DD/MM/YYYY à HH:mm');
          const splitInfoType = event.type.split('$');

          return (
            <Timeline.Item
              style={{
                marginTop: '10px'
              }}
              key={`${event.type}-${formattedDate}`}
            >
              <Text>
                {t(`history.${splitInfoType?.[0]}`, {
                  reference: splitInfoType?.[1]
                })}
              </Text>
              <br />
              <Text type="secondary" italic style={{ color: 'grey' }}>
                {t('history.item', {
                  first_name: event?.by?.first_name || '',
                  last_name: event?.by?.last_name || '',
                  date: formattedDate
                })}
              </Text>
            </Timeline.Item>
          );
        })}
      </Timeline>
    </Card>
  );
};
